import { List } from 'immutable';

import { GoogleAnalyticsEffects } from './googleAnalytics/effects';
import { SegmentEffects } from './segment/effects';

export const effects = List([GoogleAnalyticsEffects, SegmentEffects]);
